
<template>
  <div :bannerHotIndustryList='bannerHotIndustryList' class="bannerHotIndustryList">
      <div class="MobList" v-for="(item,index) in bannerHotIndustryList" :key="index">
        <div class="bannerHotIndustryListCol" @click="Enter(item)">
           <div class="bannerHotIndustryListBox">
              <div class="bannerHotIndustryListImg">
                  <img v-lazy="$funcs.compressImage(item.coverIcon)" @error="defImg()" class="lazy-img-fadein"/>
              </div>
              <p class="bannerHotIndustryListName ellipsis">{{item.title}}</p>
            </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    bannerHotIndustryList: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  data() {
    return {
        tagNameList:[],
        iconUrl:''
    }
  },
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType']),
  },
  created(){

  },
  mounted() {},
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defImage('product');
      img.onerror = null; //防止闪图
    },
    Enter(param){
      console.log(param)
      let status = this.$config.settings.onlayReg2
      if (!status) {
        this.commonStatistics('001032000', param)
      }
      window.PC.$RangersEvent("home_hot_industry_click", {
        carouselmap_id: param.id
      }, () => {
        /**
         * EXTERNAL       外部链接
         * ACTOR_DETAILS  展商详情
         * TAG_EXHIBITOR  展商列表
         */
        if (param.urlType == 'EXTERNAL') {
          if (param.url === '') {
            return
          } else {
            window.open(param.url, '_blank')
          }
        } else {
          if (status) {
            this.goLogin()
            return 
          }
          if (param.urlType=="ACTOR_DETAILS"){
            this.pageDetail(param, 'actor')
          }else if (param.urlType=="PRODUCT_DETAILS"){
            param.productId = param.url
            this.pageDetail(param, 'product')
          } else if (param.urlType == "TAG_EXHIBITOR"){
            sessionStorage.setItem('findListActor',param.url)
            this.$router.push({ path: '/find/actor' })
          } else if (param.urlType == "LIST_EXHIBITOR") {
            this.$router.push({ path: '/find/actor', query: { type: param.url } })
          } else if (param.urlType == "TAG_PRODUCT"){
            this.$router.push({ path: '/find/product', query: {type: param.url} })
          } else {
            console.log('暂时没有匹配操作')
          }

        }
      })
    }
    
  }
}
</script>

<style lang="stylus" scoped>
.MobList{
  width: 146px;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 10px;
}
.bannerHotIndustryListCol{
  cursor:pointer
  text-align:center;
  background: #fff;
  // &:hover {
  //   box-shadow: 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2;
  //   transition: 0.3s all;

  //   img {
  //     transform: scale(1.2);
  //   }
  // }
  // padding: 20px 20px 10px 20px;
}
.bannerHotIndustryListName{
  padding: 0 5px;
  line-height: 22px;
  height: 22px;
  overflow: hidden;
  color: $color-main;
  font-size:14px;
  
}
.bannerHotIndustryListImg{
  // height 200px
  overflow hidden
  margin-bottom 5px
  img{
      transition: all .3s;
      width: 100%
      height 100%
      object-fit: contain;
  }
}
  .tagList{
    height 28px
    width 170px;
    overflow hidden
  }
</style>
